// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WorkbookResultQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  workbookId: Types.Scalars["ID"]["input"];
  variantId: Types.Scalars["ID"]["input"];
  resultId: Types.Scalars["ID"]["input"];
}>;

export type WorkbookResultQuery = {
  __typename?: "GraphqlQuery";
  getWorkbookResult: {
    __typename?: "WorkbookResult";
    id: string;
    format: string;
    resultSource: string;
    createdAt: number;
    outputText?: string | null;
    annotatedJson?: any | null;
    totalCost?: number | null;
    totalSharedBlksHit?: number | null;
    totalSharedBlksRead?: number | null;
    totalSharedBlksWritten?: number | null;
    totalSharedBlksDirtied?: number | null;
    totalBlkReadTime?: number | null;
    totalBlkWriteTime?: number | null;
    planNodeTypes?: Array<string | null> | null;
    runtimeMs?: number | null;
    planFingerprint?: string | null;
    parameterSetId?: string | null;
    queryText?: string | null;
    nodeInsights?: any | null;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
    usedParameterSet?: {
      __typename?: "AliasParamMap";
      id: string;
      name: string;
      parameters: any;
    } | null;
  };
  getWorkbookDetails: {
    __typename?: "Workbook";
    id: string;
    name: string;
    description?: string | null;
    createdAt: number;
    lastActivityAt: number;
    databaseId: string;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
    parameterSets: Array<{
      __typename?: "WorkbookParameterSet";
      id: string;
      name: string;
    }>;
    baselineQuery: {
      __typename?: "WorkbookVariant";
      id: string;
      name: string;
      workbookResults: Array<{
        __typename?: "WorkbookResult";
        id: string;
        parameterSetId?: string | null;
      }>;
    };
    variants: Array<{
      __typename?: "WorkbookVariant";
      id: string;
      name: string;
      workbookResults: Array<{
        __typename?: "WorkbookResult";
        id: string;
        parameterSetId?: string | null;
      }>;
    }>;
  };
  getServerDetails: {
    __typename?: "Server";
    id: string;
    humanId: string;
    name: string;
    blockSize: number;
  };
};

export const WorkbookResultDocument = gql`
  query WorkbookResult(
    $databaseId: ID!
    $workbookId: ID!
    $variantId: ID!
    $resultId: ID!
  ) {
    getWorkbookResult(variantId: $variantId, resultId: $resultId) {
      id
      format
      resultSource
      createdAt
      outputText
      annotatedJson
      totalCost
      totalSharedBlksHit
      totalSharedBlksRead
      totalSharedBlksWritten
      totalSharedBlksDirtied
      totalBlkReadTime
      totalBlkWriteTime
      planNodeTypes
      runtimeMs
      planFingerprint
      parameterSetId
      queryText
      user {
        id
        fullname
      }
      usedParameterSet {
        id
        name
        parameters
      }
      nodeInsights
    }
    getWorkbookDetails(workbookId: $workbookId) {
      id
      name
      description
      createdAt
      lastActivityAt
      databaseId
      user {
        id
        fullname
      }
      parameterSets {
        id
        name
      }
      baselineQuery {
        id
        name
        workbookResults {
          id
          parameterSetId
        }
      }
      variants {
        id
        name
        workbookResults {
          id
          parameterSetId
        }
      }
    }
    getServerDetails(databaseId: $databaseId) {
      id
      humanId
      name
      blockSize
    }
  }
`;

/**
 * __useWorkbookResultQuery__
 *
 * To run a query within a React component, call `useWorkbookResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbookResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbookResultQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      workbookId: // value for 'workbookId'
 *      variantId: // value for 'variantId'
 *      resultId: // value for 'resultId'
 *   },
 * });
 */
export function useWorkbookResultQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkbookResultQuery,
    WorkbookResultQueryVariables
  > &
    (
      | { variables: WorkbookResultQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkbookResultQuery, WorkbookResultQueryVariables>(
    WorkbookResultDocument,
    options,
  );
}
export function useWorkbookResultLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkbookResultQuery,
    WorkbookResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorkbookResultQuery, WorkbookResultQueryVariables>(
    WorkbookResultDocument,
    options,
  );
}
// @ts-ignore
export function useWorkbookResultSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkbookResultQuery,
    WorkbookResultQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkbookResultQuery,
  WorkbookResultQueryVariables
>;
export function useWorkbookResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbookResultQuery,
        WorkbookResultQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkbookResultQuery | undefined,
  WorkbookResultQueryVariables
>;
export function useWorkbookResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbookResultQuery,
        WorkbookResultQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkbookResultQuery,
    WorkbookResultQueryVariables
  >(WorkbookResultDocument, options);
}
export type WorkbookResultQueryHookResult = ReturnType<
  typeof useWorkbookResultQuery
>;
export type WorkbookResultLazyQueryHookResult = ReturnType<
  typeof useWorkbookResultLazyQuery
>;
export type WorkbookResultSuspenseQueryHookResult = ReturnType<
  typeof useWorkbookResultSuspenseQuery
>;
export type WorkbookResultQueryResult = Apollo.QueryResult<
  WorkbookResultQuery,
  WorkbookResultQueryVariables
>;
